import { Box, Typography } from '@mui/material';
import React from 'react';
import {
  numberToString,
  stringToNumber,
} from '../../../special/numberConverter';
import { useTranslation } from 'react-i18next';

export const MatchingPropLeadFieldNumberShow = ({ property }) => {
  const { t } = useTranslation();
  const { label, publicLabel, minValue, maxValue, unit } = property;

  const hasNoValue = !minValue && !maxValue;
  const onlyOneValue =
    (Boolean(minValue) || Boolean(maxValue)) &&
    !(Boolean(minValue) == Boolean(maxValue));

  return (
    <Box className="flex items-start justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <Typography>
        {onlyOneValue
          ? `${maxValue ? t('up to') : t('starting at')} ${
              maxValue || minValue
            } ${unit ?? ''}`
          : hasNoValue
          ? '-'
          : `${numberToString(minValue)} - ${numberToString(maxValue)} ${
              unit ?? ''
            }`}
      </Typography>
    </Box>
  );
};
